<template>
  <path
    d="M11 18.0002H13C13.55 18.0002 14 17.5502 14 17.0002C14 16.4502 13.55 16.0002 13 16.0002H11C10.45 16.0002 10 16.4502 10 17.0002C10 17.5502 10.45 18.0002 11 18.0002ZM3 7.00018C3 7.55018 3.45 8.00018 4 8.00018H20C20.55 8.00018 21 7.55018 21 7.00018C21 6.45018 20.55 6.00018 20 6.00018H4C3.45 6.00018 3 6.45018 3 7.00018ZM7 13.0002H17C17.55 13.0002 18 12.5502 18 12.0002C18 11.4502 17.55 11.0002 17 11.0002H7C6.45 11.0002 6 11.4502 6 12.0002C6 12.5502 6.45 13.0002 7 13.0002Z"
  />
</template>
